export const MESSAGE_TYPE = {
  SUCCESS: 'success',
  ERROR: 'error',
};

export const CONFIG = {
  [MESSAGE_TYPE.SUCCESS]: {
    bg: '#DFF0D8',
    variant: 'successMessage',
  },
  [MESSAGE_TYPE.ERROR]: {
    bg: '#F2DEDE',
    variant: 'errorMessage',
  },
};

export const ERROR_CODE = {
  RECAPTCHA_VERIFICATION_FAILED: 'recaptcha_verification_failed',
};
